import { buildBindable } from '@monofe/di';
import type { ICallbackBuilder } from '../interface/callback';
import {
    bindCallbackBuilder,
    injectCallbackBuilder,
    unbindCallbackBuilder,
} from '../interface/callback';
import TYPES from '../interface/types';
import callbackBuilder from './callback';

export default buildBindable<ICallbackBuilder>({
    id: TYPES.ICallbackBuilder,
    dependencies: [],
    bind: bindCallbackBuilder,
    remove: unbindCallbackBuilder,
    inject: injectCallbackBuilder,
    build: () => Promise.resolve(callbackBuilder),
});
